"use strict";

var __importDefault = undefined && undefined.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NthPower = exports.Twin = exports.Triangle = exports.Prime = exports.Power = exports.Geometric = exports.Fibonacci = exports.Collatz = exports.Arithmetic = void 0;
var arithmetic_1 = require("./arithmetic");
Object.defineProperty(exports, "Arithmetic", { enumerable: true, get: function get() {
        return __importDefault(arithmetic_1).default;
    } });
var collatz_1 = require("./collatz");
Object.defineProperty(exports, "Collatz", { enumerable: true, get: function get() {
        return __importDefault(collatz_1).default;
    } });
var fibonacci_1 = require("./fibonacci");
Object.defineProperty(exports, "Fibonacci", { enumerable: true, get: function get() {
        return __importDefault(fibonacci_1).default;
    } });
var geometric_1 = require("./geometric");
Object.defineProperty(exports, "Geometric", { enumerable: true, get: function get() {
        return __importDefault(geometric_1).default;
    } });
var power_1 = require("./power");
Object.defineProperty(exports, "Power", { enumerable: true, get: function get() {
        return __importDefault(power_1).default;
    } });
var prime_1 = require("./prime");
Object.defineProperty(exports, "Prime", { enumerable: true, get: function get() {
        return __importDefault(prime_1).default;
    } });
var triangle_1 = require("./triangle");
Object.defineProperty(exports, "Triangle", { enumerable: true, get: function get() {
        return __importDefault(triangle_1).default;
    } });
var twin_1 = require("./twin");
Object.defineProperty(exports, "Twin", { enumerable: true, get: function get() {
        return __importDefault(twin_1).default;
    } });
var nthpower_1 = require("./nthpower");
Object.defineProperty(exports, "NthPower", { enumerable: true, get: function get() {
        return __importDefault(nthpower_1).default;
    } });
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./client/vendor/number-sequences/dist/index.js
// module id = 277
// module chunks = 0